import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface InlineEditingInputDisplayProps {
  children: ReactNode;
  className?: string;
}

/*
 * Style.
 */

const inputLeftOffset = 8;

const StyledInlineEditingInputDisplay = styled.div`
  margin-top: 1px;

  /* Needed to offset the margin inside the input so the text (rather than the input element as a whole) is aligned */
  position: relative;
  left: -${inputLeftOffset}px;
  min-width: calc(100% + ${2 * inputLeftOffset}px);
`;

/*
 * Component.
 */

export const InlineEditingInputDisplay: FC<InlineEditingInputDisplayProps> = (props) => {
  const {children, className} = props;

  return <StyledInlineEditingInputDisplay className={className}>{children}</StyledInlineEditingInputDisplay>;
};
